var React = require('react');

function NavIconsExperienceVersions (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m19 3.3a2.08 2.08 0 1 0 -2.6 2v2.83a3.41 3.41 0 0 1 -2.4 3.27l-2.55.79a6.87 6.87 0 0 0 -2.6 1.61v-8.63a2.07 2.07 0 1 0 -2.64-2 2.1 2.1 0 0 0 1.51 2v13.65a2.08 2.08 0 1 0 1.14 0l.07-3.35a5.28 5.28 0 0 1 2.85-2.26l2.54-.8a4.44 4.44 0 0 0 3.17-4.28v-2.84a2.06 2.06 0 0 0 1.51-1.99zm-11.57-.12a.86.86 0 1 1 .85.82.86.86 0 0 1 -.85-.82zm1.7 17.64a.86.86 0 1 1 -.85-.82.86.86 0 0 1 .85.82zm7.87-16.68a.85.85 0 0 1 0-1.7.86.86 0 0 1 .85.86.83.83 0 0 1 -.85.84z"}));
}

NavIconsExperienceVersions.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsExperienceVersions;

NavIconsExperienceVersions.default = NavIconsExperienceVersions;
